import { useAuthenticatedUser } from "@/hooks/use-authenticated-user";

export const useContractFamiliesAccess = () => {
  const user = useAuthenticatedUser();
  const isResolved = !user.isLoading && user.isAuthenticated;

  return {
    isResolved,
    hasContractFamilies: isResolved && user.organization.features.includes("contract_families"),
  };
};

/** Organization administrators own the Contract Family settings (template, Master Collection, publisher). */
export const useCanConfigureContractFamilies = (): boolean => {
  const user = useAuthenticatedUser();
  const { hasContractFamilies } = useContractFamiliesAccess();

  return hasContractFamilies && (user.pfRoles.includes("organization_admin") || user.pfRoles.includes("superadmin"));
};
